import {
	ChangeDetectionStrategy,
	Component,
	Input,
	ViewEncapsulation
} from '@angular/core';

@Component({
	selector: 'settings-item',
	template: require('./settings-item.component.html'),
	styles: [require('./settings-item.component.scss')],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsItemComponent {
	@Input('item') setting: any;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/settings/settings-overview/settings-item/settings-item.component.ts